import Vue from 'vue';
import VueRouter from 'vue-router';
// 1. Importamos la función de redirección de Keycloak
import {loginRedirect} from '@/store/keycloak';

Vue.use(VueRouter);

// =========================================================================
// PARCHE DE SEGURIDAD (Evita el error de pantalla blanca por redirección)
// =========================================================================
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Redirected') &&
            !err.message.includes('Avoided redundant navigation')
        ) {
            throw err;
        }
    });
};
// =========================================================================

const routes = [
    {path: '/process', name: 'process', meta: {title: 'Procesos'}, component: () => import('./../views/Dashboard')},
    {path: '/home', name: 'home', meta: {title: 'Mis trámites'}, component: () => import('./../views/Principal.vue')},

    // =====================================================================
    // CAMBIO IMPORTANTE AQUÍ:
    // En lugar de cargar un componente, ejecutamos loginRedirect()
    // =====================================================================
    {
        path: '/login',
        name: 'login',
        meta: {title: 'Redirigiendo a Login...'},
        beforeEnter: (to, from, next) => {
            loginRedirect(); // <--- Esto te manda a Keycloak
            // No llamamos a next() porque salimos de la app
        }
    },

    {
        path: '/verify',
        name: 'verify',
        meta: {title: 'Verificar código'},
        component: () => import('./../views/ValidateCode')
    },
    {
        path: '/reset',
        name: 'reset',
        meta: {title: 'Enviar correo de recuperación'},
        component: () => import('./../views/Reset')
    },
    {
        path: '/forgot_password',
        name: 'forgot_password',
        meta: {title: 'Recuperar contraseña'},
        component: () => import('./../views/ForgotPassword')
    },
    {path: '/register', name: 'register', meta: {title: 'Registrarme'}, component: () => import('./../views/Register')},
    {
        path: '/documents/validate',
        name: 'documents_validate',
        meta: {title: 'Validar documento'},
        component: () => import('./../views/DocumentValidation')
    },
    {
        path: '/user-profile',
        name: 'user_profile',
        meta: {title: 'Mi perfil'},
        component: () => import('./../views/UserProfile')
    },
    {
        path: '/password-update',
        name: 'password_update',
        meta: {title: 'Actualizar contraseña'},
        component: () => import('./../views/PasswordUpdate')
    },
    {
        path: '/processes',
        name: 'processes',
        meta: {title: 'Lista de procesos'},
        component: () => import('./../views/Processes')
    },
    {
        path: '/processes/:processId/requirements/:processName',
        name: 'process_requirement',
        meta: {title: 'Requerimientos'},
        component: () => import('./../views/ProcessRequirements')
    },
    {
        path: '/procedures/create/:processId',
        name: 'procedure_create',
        meta: {title: 'Iniciar trámite'},
        component: () => import('../views/ProcedureCreate')
    },
    {
        path: '/procedures/continue/:stageId',
        name: 'procedure_continue',
        meta: {title: 'Continuar trámite'},
        component: () => import('../views/ProcedureCreate')
    },
    {
        path: '/procedures/view/:stageId',
        name: 'procedure_view',
        meta: {title: 'Ver trámite'},
        component: () => import('../views/ProcedureCreate')
    },
    {
        path: '/procedures/execute/:processId',
        name: 'procedure_execute',
        meta: {title: 'Continuar trámite'},
        component: () => import('../views/ProcedureExecute')
    },
    {
        path: '/portfolio/:step',
        name: 'portfolio',
        meta: {title: 'Portafólio'},
        component: () => import('../views/Portfolio')
    },
    {path: '/orders/:action/', name: 'orders', meta: {title: 'Órdenes'}, component: () => import('./../views/Orders')},
    {
        path: '/orders/:action/:id',
        name: 'orders_details',
        meta: {title: 'Detalle de órdenes'},
        component: () => import('./../views/Orders')
    },
    {
        path: '/callback',
        name: 'callback',
        meta: {title: 'Autenticando...'},
        component: () => import('./../views/callback.vue')
    },
    {path: '/', name: 'root'} // ruta raíz
];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    const isLoggedIn = !!localStorage.getItem('userId');

    // 1. Manejo de la ruta raíz '/'
    if (to.name === 'root') {
        // Si está logueado va a procesos, si no, a home
        return next(isLoggedIn ? {name: 'process'} : {name: 'home'});
    }

    // 2. Si está logueado y trata de ir a home, lo mandamos al dashboard
    if (isLoggedIn && to.name === 'home') {
        if (from.name !== 'process') {
            return next({name: 'process'});
        }
    }

    // 3. Dejar pasar el resto
    next();
});

router.afterEach((to) => {
    document.title = to.meta?.title ? `${to.meta.title} | Trámites` : 'Trámites';
});

export default router;